module.exports = __webpack_public_path__ + "static/img/14.78816ad.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/1/20/sp/14.png
// module id = j0kG
// module chunks = 0